export default __webpack_public_path__ + "static/media/asia4.82b5abba.png";